import RecruitmentListItem from './RecruitmentListItem/RecruitmentListItem';

const COMPONENT_REGISTRY = {
    '#getClientRecruitments': RecruitmentListItem,
};

export default COMPONENT_REGISTRY;
